<div class="modal-body height-1200 width-900">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{ getResource('Header') }}
    </span>
    <div class="content">
      <div class="grid-1-auto grid-full-height">
        <div class="content">
          <div class="content layout-1-auto" style="position: relative;">
            <div class="host-container" [style.visibility]="isLoading ? 'hidden' : 'visible'" style="height: 100%">
              <div *ngIf="currentResource" style="height: 100%;">
                <div class="pdf-viewer-box" style="height: 1px;">
                  <pdf-viewer class="host-pdf-view" style="display: block;"
                              [src]="currentResource || null"
                              [render-text]="false" [original-size]="true" [fit-to-page]="true"
                              [show-borders]="true"
                              [show-all]="true"
                              (after-load-complete)="pdfLoaded()"></pdf-viewer>
                </div>
              </div>
            </div>
            <div *ngIf="isLoading" class="content" style="position: absolute; top: 0; right: 0; bottom: 0; left: 0;">
              <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spawn-modal-actions">
      <button (click)="close()" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
    </div>
  </div>
</div>
